/* unplugin-vue-components disabled */import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import PopupPicker from "vux/src/components/popup-picker/index.vue"; // this line is trasformed by vux-loader
import PopupRadio from "vux/src/components/popup-radio/index.vue"; // this line is trasformed by vux-loader
import Group from "vux/src/components/group/index.vue"; // this line is trasformed by vux-loader
import XInput from "vux/src/components/x-input/index.vue"; // this line is trasformed by vux-loader
import XButton from "vux/src/components/x-button/index.vue"; // this line is trasformed by vux-loader
import Datetime from "vux/src/components/datetime/index.vue"; // this line is trasformed by vux-loader
import XSwitch from "vux/src/components/x-switch/index.vue"; // this line is trasformed by vux-loader
import ChinaAddressV4Data from "vux/src/datas/china_address_v4.json"; // this line is trasformed by vux-loader
import XTextarea from "vux/src/components/x-textarea/index.vue"; // this line is trasformed by vux-loader
import Checklist from "vux/src/components/checklist/index.vue"; // this line is trasformed by vux-loader
import TransferDom from "vux/src/directives/transfer-dom/index.js"; // this line is trasformed by vux-loader
import Cell from "vux/src/components/cell/index.vue"; // this line is trasformed by vux-loader
import CellBox from "vux/src/components/cell-box/index.vue"; // this line is trasformed by vux-loader
import Popup from "vux/src/components/popup/index.vue"; // this line is trasformed by vux-loader
import SinglePicker from '@/components/Base/SinglePicker';
import { getBreakdownPatternTypeList, getBreakdownPatternList as _getBreakdownPatternList } from '@/api';
export default {
  name: 'AddFault',
  components: {
    ViewBox: ViewBox,
    PopupPicker: PopupPicker,
    PopupRadio: PopupRadio,
    Group: Group,
    XInput: XInput,
    XButton: XButton,
    Datetime: Datetime,
    XSwitch: XSwitch,
    ChinaAddressV4Data: ChinaAddressV4Data,
    XTextarea: XTextarea,
    Checklist: Checklist,
    TransferDom: TransferDom,
    Cell: Cell,
    CellBox: CellBox,
    Popup: Popup,
    SinglePicker: SinglePicker
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showMask: {
      type: Boolean,
      default: false
    },
    faultsOld: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      storehouse_type: 0,
      currValue: this.value,
      form: {
        productionSn: '',
        productName: '',
        productId: '',
        purchasing_date: ''
      },
      isAddProductModal: false,
      isShowSelectProductModal: false,
      breakDown: [],
      faults: []
    };
  },
  computed: {
    // 计算滚动区域高度
    scrollerHight: function scrollerHight() {
      var fontSize = window.getComputedStyle(window.document.documentElement)['font-size'];
      fontSize = Number(fontSize.substr(0, fontSize.length - 2));
      return document.documentElement.clientHeight - (4 + 4 + 0.8) * fontSize;
    },
    DingTalk: function DingTalk() {
      return this.$DingTalk;
    }
  },
  watch: {
    value: function value(val) {
      this.currValue = val;
    },
    currValue: function currValue(val) {
      if (val) {
        this.faults = this.faultsOld.length ? this.faultsOld : [{
          breakdownPatternCategoryId: '',
          breakdownPatternId: '',
          descri: ''
        }];
      }
      this.$emit('input', val);
    }
  },
  methods: {
    addFault: function addFault() {
      this.faults.push({
        breakdownPatternCategoryId: '',
        breakdownPatternId: '',
        descri: ''
      });
    },
    setItemDesc: function setItemDesc(e, item) {
      var tmp = item.breakDownList.find(function (v) {
        return v.id === +e[0];
      });
      var descri = tmp ? tmp.descri : '';
      this.$set(item, 'descri', descri);
    },
    getBreakdownPatternList: function getBreakdownPatternList(typeId, item) {
      var _this = this;
      _getBreakdownPatternList({
        typeId: typeId
      }).then(function (res) {
        if (res.success) {
          _this.$set(item, 'breakDownList', res.data);
        }
      });
    },
    init: function init() {
      var _this2 = this;
      getBreakdownPatternTypeList().then(function (res) {
        if (res.success) {
          _this2.breakDown = res.data;
        }
      });
    },
    selectProduct: function selectProduct(e) {
      var selectionObj = this.form;
      selectionObj.productName = e.name;
      selectionObj.productId = e.id;
      selectionObj.productionTypeId = e.fk_t_production_category_id;
    },
    // 获取产品名称
    getProductName: function getProductName(index) {
      this.isShowSelectProductModal = true;
    },
    submit: function submit() {
      // if (!this.form.purchasing_date) return this.$vux.toast.text('请选择购买时间')
      this.$emit('callback', JSON.parse(JSON.stringify(this.faults)));
      this.currValue = false;
    }
  },
  created: function created() {
    this.init();
  }
};